import { COMMUNITY_CONTRACT_TYPE } from '../constants';

export const COMMUNITY_LIFE_PLAN_CONTRACT_TYPES = [
  COMMUNITY_CONTRACT_TYPE.TYPE_A,
  COMMUNITY_CONTRACT_TYPE.TYPE_B,
  COMMUNITY_CONTRACT_TYPE.TYPE_C,
];
